/* eslint-disable i18next/no-literal-string */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import logo from 'assets/generated/images/logo-dark.png';
import styles from './LandingHeaderV2.module.scss';

export default function LandingHeader() {
  const history = useHistory();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        <img src={logo} alt="logo" height={48} />
        <div
          className={classNames(styles.hamburger, isMobileMenuOpen && styles.active)}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <div className={styles.bar} />
          <div className={styles.bar} />
          <div className={styles.bar} />
        </div>
        <div className={classNames(styles.nav, isMobileMenuOpen && styles.active)}>
          <div className={styles.navItem}>
            <a href="/">Home</a>
          </div>
          <div className={styles.navItem}>
            <a href="/virtual-staging">Virtual staging</a>
          </div>
          <div className={styles.navItem}>
            <a href="/floor-plan">Floor plan & Interior rendering</a>
          </div>
          <div className={styles.navItem}>
            <a href="/ai-generation">AI generation</a>
          </div>
        </div>
        <Button
          variant="primary"
          onClick={() => {
            history.push('/get-started');
          }}
        >
          Sign Up Now
        </Button>
      </div>
    </div>
  );
}
